/** Gets the common values between two arrays. */
export const getArrayIntersection = <T>(largerArray: T[], smallerArray: T[]): T[] => {
  return largerArray?.filter((arrayItem) => smallerArray?.includes(arrayItem));
};

/** Determines if arrays of primitive values are equal - i.e. same value at every index. */
// Code copied from: https://stackoverflow.com/a/16436975
export const areArraysEqual = (arrA: unknown[], arrB: unknown[]) => {
  // Pre-checks
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  if (arrA.length !== arrB.length) {
    return false;
  }

  // Full checks
  for (let i = 0; i < arrA.length; ++i) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
};

/**
 * Determines if two **object** arrays are completely equal.
 * True = For every object in arr_A, it has a matching object in arr_B, and they share the same keys + values.
 * @param arrA
 * @param arrB
 * @param keyForMatching The key to use to find a matching object between the two arrays.
 */
export const areObjectArraysEqual = <T>(arrA: T[], arrB: T[], keyForMatching: string) => {
  if (!arrA || !arrB) {
    return false;
  }

  if (arrA.length !== arrB.length) {
    return false;
  }

  const areObjectArraysEqual = arrA.every((objA) => {
    return Object.keys(objA).every((objAKey) => {
      const matchingObjB = arrB.filter((objB) => objB[keyForMatching] === objA[keyForMatching])[0];
      return matchingObjB && objA[objAKey] === matchingObjB[objAKey];
    });
  });

  return areObjectArraysEqual;
};
